export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/CapitalOne/theme/components/scorecard/MetricsLabels/index.js